<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>
            &nbsp;&nbsp;&nbsp;Manage Practice Configuration
            <span style="padding-left:50px;" class="alert-icon">⚠️</span>
            <span style="text-align:center; font-size: 15px !important; color: #fffa5f; "> User must must log out and log back in for practice config changes to take effect. </span>
        </h2>
    </div>
</div>
<div class="">
    <span style="float:right;padding-top:7px;padding-right:5px;" *ngIf="isImportSettingVisiable">
        <button pButton icon="pi pi-file-import" label="Import from config file" (click)="fetchPracticeSettingsFromXmlFile()"></button>&nbsp;
        <button pButton icon="pi pi-undo" label="Clear Settings" (click)="resetSettings();" [disabled]="isDisabled"></button>
    </span>
</div>
<div class="card" id="practicemainId" style="background-color:white !important">
    <div class="field col-6 md:col-4 T mb-0 pt-3 p-fluid">


        <label class="pl-4 Font" style="font-size: 14px; font-weight:bold;"> Select Practice </label>
        <span> <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="bottom" (mouseover)="getContolTip('SELECTPRACTICE')"></i></span>
        <span class="p-float-label pl-3 D mb-2">
            <p-dropdown [formControl]="practice" [options]="practices | async" optionLabel="name" optionValue="emrPracticeId"></p-dropdown>
        </span>
    </div>

    <form class="pb-0 pt-0 col-12" [formGroup]="frmPracticeSettings" (ngSubmit)="onSubmit()">
        <p-panel class="p-fluid">
            <h5 class="col-5 md:col-1 blueBar mt-2 mb-2 ml-2 mr-3 r-2">
                Application Features
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid paddingcb">
                <div class="col-6 md:col-3">
                    <span class="">
                        <input id="ShowAppointment"
                               type="checkbox"
                               formControlName="showAppointment"
                               binary="true" />
                        <label class="pl-2 Font">
                            Patient Appointments
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('PATIENTAPPOINTMENTS')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="showPatientImage"
                               type="checkbox"
                               formControlName="showPatientImage"
                               binary="true" />
                        <label class="pl-2 Font">
                            Patient Images<i class="pi pi-exclamation-circle pt-1"
                                             pTooltip="{{ speakText }}"
                                             tooltipPosition="top"
                                             (mouseover)="getContolTip('PATIENTIMAGES')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-6 md:col-3">
                    <span>
                        <input id="ShowPatientDocuments"
                               type="checkbox"
                               binary="true"
                               formControlName="showPatientDocuments" />
                        <label class="pl-2 Font">
                            Patient Documents
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="top"
                               (mouseover)="getContolTip('PATIENTDOCUMENTS')"></i>
                        </label>
                    </span>
                </div>


                <div class="col-6 md:col-3">
                    <span class="">
                        <input id="enablePatientDemographicPrint"
                               type="checkbox"
                               formControlName="enablePatientDemographicPrint"
                               binary="true" />
                        <label class="pl-2 Font">
                            Print Patient Data
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('PRINTPATIENTSCREEN')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="ShowExportCCDA"
                               type="checkbox"
                               formControlName="showExportCCDA"
                               binary="true" />

                        <label class="pl-2 Font">
                            Show Export CCDA
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('SHOWEXPORTCCDA')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="ShowExportDocuments"
                               type="checkbox"
                               formControlName="showExportDocuments"
                               binary="true" />
                        <label class="pl-2 Font">
                            Export Documents<i class="pi pi-exclamation-circle pt-1"
                                               pTooltip="{{ speakText }}"
                                               tooltipPosition="right"
                                               (mouseover)="getContolTip('EXPORTDOCUMENTS')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="EnableFinancialSummary"
                               type="checkbox"
                               formControlName="enableFinancialSummary"
                               binary="true" />
                        <label class="pl-2 Font">
                            Financial Summary
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('FINANCIALSUMMARY')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="ShowPatientNotes"
                               type="checkbox"
                               formControlName="showPatientNotes"
                               binary="true" />
                        <label class="pl-2 Font">
                            Patient Notes
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('PATIENTNOTES')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="IsArchiveInstance"
                               type="checkbox"
                               formControlName="isArchiveInstance"
                               binary="true" />
                        <label class="pl-2 Font">
                            Archive Instance
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('ARCHIVEINSTANCE')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="ShowpatientArchive"
                               type="checkbox"
                               formControlName="showPatientArchive"
                               binary="true" />
                        <label class="pl-2 Font">
                            Patient Live Archive<i class="pi pi-exclamation-circle pt-1"
                                                   pTooltip="{{ speakText }}"
                                                   tooltipPosition="right"
                                                   (mouseover)="getContolTip('PATIENTARCHIVE')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span class="">
                        <input id="isSignificantEvent"
                               type="checkbox"
                               formControlName="isSignificantEvent"
                               binary="true" />
                        <label class="pl-2 Font">
                            Significant Events
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('SIGNIFICANTEVENTS')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="ShowRestoreTabToUser"
                               type="checkbox"
                               formControlName="showRestoreTabToUser"
                               binary="true" />
                        <label class="pl-2 Font">
                            Patient Restore
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('PATIENTRESTORE')"></i>
                        </label>
                    </span>
                </div>



                <div class="col-6 md:col-3" *ngIf="true">

                    <span>
                        <input id="showPatientDemographics"
                               type="checkbox"
                               formControlName="showPatientDemographics"
                               binary="true" />
                        <label class="pl-2 Font">
                            Update Patient Demographics
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('SHOWPATIENTDEMOGRAPHICS')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3" *ngIf="true">

                    <span>
                        <input id="showPatientPayer"
                               type="checkbox"
                               formControlName="showPatientPayer"
                               binary="true" />
                        <label class="pl-2 Font">
                            Create Patient Payor
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('SHOWPATIENTPAYER')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3 " *ngIf="isGlobalAdmin">
                    <span>
                        <input id="showSensitiveData"
                               type="checkbox"
                               formControlName="showSensitiveData"
                               binary="true" />
                        <label class="pl-2 Font">
                            Show Sensitive Data
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('SHOWSENSITIVEDATA')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="enableDocumentDownloads"
                               type="checkbox"
                               formControlName="enableDocumentDownloads"
                               binary="true" />
                        <label class="pl-2 Font">
                            Download Documents
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('ENABLEDOCUMENTDOWNLOADS')"></i>
                        </label>
                    </span>
                </div>

            </div>

            <h5 class="col-5 md:col-1 blueBar mt-4 mb-3 ml-2 mr-3 r-2">
                General Settings
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid">
                <div class="col-6 md:col-3">
                    <label class="pl-3 Font">
                        Default Appointment Type
                    </label>
                    <span>
                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('DEFAULTAPPOINTMENTTYPE')"></i>
                    </span>
                    <span class="p-float-label pl-2 P">
                        <p-dropdown formControlName="defaultAppointmentType"
                                    [options]="referringOptions"
                                    optionLabel="value"
                                    optionValue="key"
                                    dataKey="value">
                        </p-dropdown>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <label class="pl-3 Font">
                        Patient Default Page
                    </label>
                    <span>
                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('patientDefaultPage')"></i>
                    </span>
                    <span class="p-float-label pl-2 P">
                        <p-dropdown formControlName="patientDefaultPage"
                                    [options]="patientDefaultPageOptions"
                                    optionLabel="value"
                                    optionValue="key"
                                    dataKey="value">
                        </p-dropdown>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <label class="pl-3 Font">
                        Chart Unit
                    </label>
                    <span>
                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('chartUnit')"></i>
                    </span>
                    <span class="p-float-label pl-2 P">
                        <p-dropdown formControlName="chartUnit"
                                    [options]="chartUnitOptions"
                                    optionLabel="value"
                                    optionValue="key"
                                    dataKey="value">
                        </p-dropdown>
                    </span>
                </div>

                <div class="col-6 md:col-3" style="align-content: end;">
                    <span>
                        <input id="showPracticeMessagePopUp"
                               type="checkbox"
                               formControlName="showPracticeMessagePopUp"
                               binary="true" />
                        <label class="pl-2 Font">
                            Show Practice Message Pop-Up
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('SHOWPRACTICEMESSAGEPOPUP')"></i>
                        </label>
                    </span>
                </div>
            </div>


            <h5 class="col-5 md:col-1 blueBar mt-4 mb-2 ml-2 mr-3 r-2">
                S3 Configurations
            </h5>
            <div class="col-6 md:col-3">
                <span class="Font">
                    <input id="enableInputS3" #enableS3Input
                           type="checkbox"
                           formControlName="enableInputS3"
                           binary="true" />
                    <label class="Font">
                        Input S3 Configuration
                        <i class="pi pi-exclamation-circle pt-1"
                           pTooltip="{{ speakText }}"
                           tooltipPosition="right"
                           (mouseover)="getContolTip('InputS3Configuration')"></i>
                    </label>
                </span>
            </div>
            <div class="grid col-12">

                <div class="col-12 grid paddingcb">
                    <div class="col-6 md:col-3 padding3c pl-3">
                        <label for="inputS3AccessKey">Access Key ID<i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('inputS3AccessKey')"></i></label>
                        <input id="inputS3AccessKey" type="password" pInputText formControlName="inputS3AccessKey" [ngClass]="{'ng-invalid ng-touched': frmPracticeSettings.get('inputS3AccessKey')?.invalid && frmPracticeSettings.get('inputS3AccessKey')?.touched }" />

                        <span *ngIf="frmPracticeSettings.get('inputS3AccessKey')?.touched && frmPracticeSettings.get('inputS3AccessKey')?.hasError('required')" style="color:orangered">
                            Access key is required.
                        </span>
                    </div>

                    <div class="col-6 md:col-3 paddingll">
                        <label for="inputS3SecretKey">Secret Access Key<i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('inputS3SecretKey')"></i></label>
                        <input id="inputS3SecretKey" type="password" pInputText formControlName="inputS3SecretKey" />
                        <span *ngIf="frmPracticeSettings.get('inputS3SecretKey')?.touched && frmPracticeSettings.get('inputS3SecretKey')?.hasError('required')" style="color:orangered">
                            Secret access  key is required.
                        </span>
                    </div>

                    <div class="col-6 md:col-3">
                        <label for="inputAwsBucket">AWS Bucket Name<i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('inputAwsBucket')"></i></label>
                        <input id="inputAwsBucket" type="text" pInputText formControlName="inputAwsBucket" />
                        <span *ngIf="frmPracticeSettings.get('inputAwsBucket')?.touched && frmPracticeSettings.get('inputAwsBucket')?.hasError('required')" style="color:orangered">
                            AWS bucket name is required.
                        </span>
                    </div>

                    <div class="col-6 md:col-3">
                        <label for="inputS3Region">Region<i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('inputS3Region')"></i></label>
                        <input id="inputS3Region" type="text" pInputText formControlName="inputS3Region" />
                        <span *ngIf="frmPracticeSettings.get('inputS3Region')?.touched && frmPracticeSettings.get('inputS3Region')?.hasError('required')" style="color:orangered">
                            Region name is required.
                        </span>
                    </div>
                </div>
            </div>
            <div class="grid col-12">
                <div class="col-6 md:col-3">
                    <span class="p-float-label pl-2 P" *ngIf="enableS3Input.checked" (click)="testConnection('Input')">
                        <p-button label="Test Input S3 Connection"> </p-button>
                    </span>
                </div>
            </div>

            <div class="col-6 md:col-3">
                <span class="Font">
                    <input id="enableoutputs3" #enableS3Output
                           type="checkbox"
                           formControlName="enableOutputS3"
                           binary="true" />
                    <label class="Font">
                        Output S3 Configuration
                        <i class="pi pi-exclamation-circle pt-1"
                           pTooltip="{{ speakText }}"
                           tooltipPosition="right"
                           (mouseover)="getContolTip('outputS3Configuration')"></i>
                    </label>
                </span>
            </div>
            <div id="outputSettingS3AndLocal" class="col-12">

                <!-- S3 Output Settings -->
                <div class="col-12 grid paddingcb">
                    <div class="col-6 md:col-3 padding3c pl-3">
                        <label for="outputS3AccessKey">
                            Access Key ID
                            <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                               (mouseover)="getContolTip('outputS3AccessKey')"></i>

                        </label>
                        <input id="outputS3AccessKey"
                               type="password"
                               pInputText
                               formControlName="outputS3AccessKey" />

                        <span *ngIf="frmPracticeSettings.get('outputS3AccessKey')?.touched && frmPracticeSettings.get('outputS3AccessKey')?.hasError('required')" style="color:orangered">
                            Access key ID is required.
                        </span>
                    </div>

                    <div class="col-6 md:col-3 paddingll">
                        <label for="outputS3SecretKey">
                            Secret Access Key

                            <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                               (mouseover)="getContolTip('outputS3SecretKey')"></i>
                        </label>
                        <input id="outputS3SecretKey"
                               type="password"
                               pInputText
                               formControlName="outputS3SecretKey" />
                        <span *ngIf="frmPracticeSettings.get('outputS3SecretKey')?.touched && frmPracticeSettings.get('outputS3SecretKey')?.hasError('required')" style="color:orangered">
                            Secret Access Key is required.
                        </span>
                    </div>

                    <div class="col-6 md:col-3">
                        <label for="outputAwsBucket">
                            AWS Bucket Name
                            <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                               (mouseover)="getContolTip('outputAwsBucket')"></i>

                        </label>
                        <input id="outputAwsBucket"
                               type="text"
                               pInputText
                               formControlName="outputAwsBucket" />

                        <span *ngIf="frmPracticeSettings.get('outputAwsBucket')?.touched && frmPracticeSettings.get('outputAwsBucket')?.hasError('required')" style="color:orangered">
                            AWS Bucket Name is required.
                        </span>
                    </div>
                    <div class="col-6 md:col-3">
                        <label for="outputS3Region">
                            Region
                            <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                               (mouseover)="getContolTip('outputS3Region')"></i>

                        </label>
                        <input id="outputS3Region"
                               type="text"
                               pInputText
                               formControlName="outputS3Region" />
                        <span *ngIf="frmPracticeSettings.get('outputS3Region')?.touched && frmPracticeSettings.get('outputS3Region')?.hasError('required')" style="color:orangered">
                            Region Name is required.
                        </span>
                    </div>

                </div>
            </div>
            <div class="grid col-12">
                <div class="col-6 md:col-3">

                    <span class="p-float-label pl-2 P" *ngIf="enableS3Output.checked" (click)="testConnection('Output')">
                        <p-button label="Test Output S3 Connection"> </p-button>
                    </span>
                </div>
            </div>
            <h5 class="col-5 md:col-1 blueBar mt-4 mb-2 ml-2 mr-3 r-2">
                Documents & Images
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="grid col-12">
                <div class="col-6 md:col-3">
                    <label class="pl-2 Font">
                        Document Storage Type
                    </label>
                    <span>
                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('INPUTSTORETYPE')"></i>
                    </span>
                    <span class="p-float-label pl-2 P">
                        <p-dropdown formControlName="inputStorageType"
                                    [options]="inputStorageTypeOptions"
                                    optionLabel="value"
                                    optionValue="key"
                                    dataKey="value">
                        </p-dropdown>

                    </span>
                </div>
            </div>

            <div class="col-12 grid paddingcb">
                <!-- S3 Input Settings -->
                <div id="inputSettingS3AndLocal" class="col-12">
                    <div class="col-12 grid" *ngIf="isInputStoreType_local">
                        <!-- Local Input Settings -->
                        <div class="col-6 md:col-3">
                            <label for="DocumentFolder"> Document Folder Path<i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('DOCUMENTFOLDERPATH')"></i> </label>
                            <input id="DocumentFolder" type="text" pInputText formControlName="documentFolderPath" />
                        </div>

                    </div>
                    <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3; " />

                    <div class="grid col-12">
                        <div class="col-6 md:col-3">
                            <label class="pl-1 Font">
                                Image Storage Type
                            </label>
                            <span>
                                <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('INPUTSTORETYPEIMAGE')"></i>
                            </span>
                            <span class="p-float-label pl-1 P">
                                <p-dropdown formControlName="imageStorageType"
                                            [options]="inputStorageTypeOptions"
                                            optionLabel="value"
                                            optionValue="key"
                                            dataKey="value">
                                </p-dropdown>

                            </span>
                        </div>
                        <div class="col-12 grid" *ngIf="isInputStoreType_local">
                            <div class="col-6 md:col-3">
                                <label for="ImageFolder"> Image Folder Path <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('IMAGEFOLDERPATH')"></i></label>
                                <input id="ImageFolder" type="text" pInputText formControlName="imageFolderPath" />
                            </div>
                            <div class="col-6 md:col-3">
                                <label for="ICSFolder">ICS image Folder Path<i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('ICSIMAGEFOLDERPATH')"></i></label>
                                <input id="ICSFolder" type="text" pInputText formControlName="icsFolderPath" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="grid col-12">
                <div class="col-6 md:col-4">
                    <label class="pl-3 Font">
                        Notes Storage Type
                    </label>
                    <span>
                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('NOTESSTORETYPE')"></i>
                    </span>
                    <span class="p-float-label pl-2 P">
                        <p-dropdown formControlName="notesStorageType"
                                    [options]="inputStorageTypeOptions"
                                    optionLabel="value"
                                    optionValue="key"
                                    dataKey="value">
                        </p-dropdown>
                    </span>
                </div>
            </div>

            <div class="col-6 md:col-4 paddingll">
                <label class="pl-3 Font" for="NotesFolder">Notes Folder Path<i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('NOTESFOLDERPATH')"></i></label>
                <span class="p-float-label pl-2 P">
                    <input id="notesFolder" type="text" pInputText formControlName="notesFolder" appFormErrorMessages />
                </span>
                <span *ngIf="frmPracticeSettings.get('notesFolder')?.touched && frmPracticeSettings.get('notesFolder')?.hasError('required')" style="color:orangered">
                    Notes Path is Required.
                </span>
            </div>


            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid paddingcb">
                <!-- Output Settings -->
                <div class="grid col-12">

                    <div class="col-6 md:col-3">
                        <label class="pl-3 Font">
                            Output Storage Type
                        </label>
                        <span>
                            <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('OUTPUTSTORETYPE')"></i>
                        </span>
                        <span class="p-float-label pl-2 P">
                            <p-dropdown formControlName="outputStorageType"
                                        [options]="outputStorageTypeOptions"
                                        optionLabel="value"
                                        optionValue="key"
                                        dataKey="value"
                                        tooltip="Select  output Storage Type">
                            </p-dropdown>

                        </span>
                    </div>
                </div>

                <div id="outputSettingS3AndLocal" class="col-12">



                    <div class="col-12 grid paddingcb" *ngIf="isOutputStoreType_local">
                        <div class="col-6 md:col-4 padding3c pl-3">
                            <label for="OutputFolder">Output Folder Path<i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('OutputFolderPath')"></i></label>
                            <input id="OutputFolder" type="text" pInputText formControlName="outputFolderPath" />
                        </div>
                        <div class="col-6 md:col-4 padding3c pl-3">
                            <label for="ExportDocumentFolder">Export Document Path<i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('EXPORTDOCUMENTFOLDERPATH')"></i></label>
                            <input id="ExportDocumentFolder" type="text" pInputText formControlName="exportDocumentFolder" />
                        </div>
                    </div>
                </div>
            </div>

            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="grid col-12">
                <div class="col-6 md:col-4">
                    <label class="pl-3 Font" for="ConvertFolder">
                        Convert Folder Path
                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('CONVERTFOLDERPATH')"></i>
                    </label>
                    <span>
                        <input id="ConvertFolder"
                               type="text"
                               pInputText
                               formControlName="convertFolderPath" />
                    </span>
                </div>
                <div class="col-6 md:col-4">
                    <label for="XSLTFilePath" class="mr-3">
                        XSLT Folder Path
                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('XSLTFOLDERPATH')"></i>
                    </label>
                    <input id="XSLTFilePath"
                           type="text"
                           pInputText
                           formControlName="xsltFilePath" />
                </div>
                <div class="col-6 md:col-4">
                    <label for="LeadConvertAppPath">
                        Lead Converter App Path

                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('LEADCONVERTERAPPPATH')"></i>

                    </label>
                    <input id="LeadConvertAppPath"
                           type="text"
                           pInputText
                           formControlName="leadConvertAppPath" />
                </div>
            </div>
            <div class="grid col-12">
                <div class="col-6 md:col-3">
                    <span class="pl-3 Font">
                        <input id="BrowserPDFViewer"
                               type="checkbox"
                               formControlName="browserPDFViewer"
                               binary="true" />
                        <label class="pl-2 Font">
                            Browser PDF Viewer
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('BROWSERPDFVIEWER')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="IsImageZipped"
                               type="checkbox"
                               formControlName="isImageZipped"
                               binary="true" />
                        <label class="pl-2 Font">
                            Image Files Zipped<i class="pi pi-exclamation-circle pt-1"
                                                 pTooltip="{{ speakText }}"
                                                 tooltipPosition="right"
                                                 (mouseover)="getContolTip('IMAGEFILESZIPPED')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="DisableEmbeddedFonts"
                               type="checkbox"
                               formControlName="disableEmbeddedPDFFonts"
                               binary="true" />
                        <label class="pl-2 Font">
                            Disable Embedded Fonts
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('DISABLEEMBEDDEDFONTS')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="isEmptyInputFromTemplate"
                               type="checkbox"
                               formControlName="isEmptyInputFromTemplate"
                               binary="true" />

                        <label class="pl-2 Font">
                            Display Blank Fields (Note Templates)
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('ISREMOVEEMPTYINPUTFROMNOTETEMPLATE')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-6 md:col-3">


                    <!--<span class="p-float-label T">
                <p-dropdown formControlName="patientImageViewType"
                            [options]="patientImageViewTypeOptions"
                            optionLabel="value"
                            optionValue="key"
                            dataKey="value"
                            tooltip="Select patient images View type">
                </p-dropdown>


                <label style="font-size: 14px" for="PatientImagesView">
                    Patient Images View
                    <i class="pi pi-exclamation-circle pt-1" id="PatientImagesView"
                       pTooltip="{{ speakText }}"
                       tooltipPosition="right"
                       (mouseover)="getContolTip('PatientImagesView')"></i>
                </label>
            </span>-->



                    <label class="pl-3 Font">
                        Patient Images View
                    </label>
                    <span>
                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('PATIENTIMAGEVIEW')"></i>
                    </span>
                    <span class="p-float-label pl-2 P">
                        <p-dropdown formControlName="patientImageViewType"
                                    [options]="patientImageViewTypeOptions"
                                    optionLabel="value"
                                    optionValue="key"
                                    dataKey="value">
                        </p-dropdown>
                    </span>
                </div>
            </div>


            <!-- Single RTF Settings -->

            <h5 class="col-5 md:col-1 blueBar mt-4 mb-2 ml-2 mr-3 r-2">
                RTF Settings
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid paddingcb" formGroupName="singleRTFSetting">
                <div class="col-12 md:col-12">
                    <span class="pl-2 Font">
                        <input id="SetRTFMargins" type="checkbox" formControlName="margins" binary="true" />
                        <label class="pl-2 Font" for="SetRTFMargins">
                            Set RTF Margins<i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('RTFSETTINGS')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3 paddingl">
                    <label class="pl-3 Font" for="LeftMarginRTF">
                        Left Margin
                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('LEFTMARGIN')"></i>
                    </label>
                    <span class="p-float-label pl-3 P">
                        <input id="LeftMarginRTF" type="number" pInputText formControlName="leftMargin" [disabled]="isDisabled_RtfSingle" />
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <label for="RightMarginRTF">
                        Right Margin

                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('RIGHTMARGIN')"></i>

                    </label>
                    <input id="RightMarginRTF"
                           type="number"
                           pInputText
                           formControlName="rightMargin"
                           [disabled]="isDisabled_RtfSingle" />
                </div>

                <div class="col-6 md:col-3">
                    <label for="TopMarginRTF">
                        Top Margin

                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('TOPMARGIN')"></i>
                    </label>
                    <input id="TopMarginRTF"
                           type="number"
                           pInputText
                           formControlName="topMargin"
                           [disabled]="isDisabled_RtfSingle" />
                </div>

                <div class="col-6 md:col-3">
                    <label for="BottomMarginRTF">
                        Bottom Margin

                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('BOTTOMMARGIN')"></i>

                    </label>
                    <input id="BottomMarginRTF"
                           type="number"
                           pInputText
                           formControlName="bottomMargin"
                           [disabled]="isDisabled_RtfSingle" />
                </div>

                <div class="col-6 md:col-3">
                    <label class="pl-3 Font">
                        Orientation
                    </label>
                    <span>
                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('ORIENTATION')"></i>
                    </span>
                    <span class="p-float-label pl-2 P">
                        <p-dropdown formControlName="orientation"
                                    [options]="rtfOrientationOptions"
                                    optionLabel="value"
                                    optionValue="key"
                                    dataKey="value"
                                    [disabled]="isDisabled_RtfSingle">
                        </p-dropdown>
                    </span>
                </div>
            </div>

            <h5 class="col-5 md:col-1 blueBar mt-4 mb-2 ml-2 mr-3 r-2">
                Multiple RTF Settings
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid paddingcb" formGroupName="rtfConversionSettings">
                <div class="col-6 md:col-3">
                    <span>
                        <input id="ForceNewLineBeforeHeader"
                               type="checkbox"
                               formControlName="forceNewLineBeforeHeader"
                               binary="true" />
                        <label class="pl-2 Font">
                            Force New Line Before Header
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('FORCENEWLINEBEFOREHEADER')"></i>
                        </label>
                    </span>
                </div>



                <div class="col-6 md:col-3">
                    <span>
                        <input id="SkipHeaderIfRTFBlank"
                               type="checkbox"
                               formControlName="skipHeaderIfRTFBlank"
                               binary="true" />
                        <label class="pl-2 Font">
                            Skip Header If RTF Blank
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('SkipHeaderIfRTFBlank')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-12 md:col-3">
                    <span>
                        <input id="ForceNewLineAfterHeader"
                               type="checkbox"
                               formControlName="forceNewLineAfterHeader"
                               binary="true" />
                        <label class="pl-2 Font">
                            Force New Line After Header<i class="pi pi-exclamation-circle pt-1"
                                                          pTooltip="{{ speakText }}"
                                                          tooltipPosition="right"
                                                          (mouseover)="getContolTip('FORCENEWLINEAFTERHEADER')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-6 md:col-3" formGroupName="headerFormat">
                    <span>
                        <input id="BoldHeaderText"
                               type="checkbox"
                               formControlName="bold"
                               binary="true" />
                        <label class="pl-2 Font">
                            Header Format Bold<i class="pi pi-exclamation-circle pt-1"
                                                 pTooltip="{{ speakText }}"
                                                 tooltipPosition="right"
                                                 (mouseover)="getContolTip('HEADERFORMATBOLD')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3" formGroupName="headerFormat">
                    <span>
                        <input id="HeaderUnderLine"
                               type="checkbox"
                               formControlName="underline"
                               binary="true" />
                        <label class="pl-2 Font">
                            Header Format Underline
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('HEADERFORMATUNDERLINE')">
                            </i>
                        </label>
                    </span>
                </div>



                <div class="col-6 md:col-3" formGroupName="headerFormat">
                    <span>
                        <input id="HeaderUnderLine"
                               type="checkbox"
                               formControlName="underline"
                               binary="true" />
                        <label class="pl-2 Font">
                            Header Format Underline
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('HEADERFORMATUNDERLINE')">
                            </i>
                        </label>
                    </span>
                </div>
            </div>

            <div formGroupName="rtfConversionSettings">
                <div class="col-12 grid paddingl">
                    <div class="col-6 md:col-3">
                        <label class="pl-3 Font" for="RtfFileName">
                            RTF File Name
                            <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                               (mouseover)="getContolTip('rtfFileName')"></i>
                        </label>
                        <span class="p-float-label pl-3 P">
                            <input id="RtfFileName" type="text" pInputText formControlName="rtfFileName" />
                        </span>
                    </div>
                    <div class="col-6 md:col-3" formGroupName="headerFormat">
                        <label for="HeaderFontSize">
                            Header Format Font Size
                            <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                               (mouseover)="getContolTip('HEADERFORMATFONTSIZE')"></i>
                        </label>
                        <input id="HeaderFontSize"
                               type="number"
                               pInputText
                               formControlName="fontSize" />
                    </div>

                    <div class="col-6 md:col-3" formGroupName="headerFormat">
                        <label for="HeaderFontName">
                            Header Format Font Name


                            <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                               (mouseover)="getContolTip('HEADERFORMATFONTNAME')"></i>

                        </label>
                        <input id="HeaderFontName"
                               type="text"
                               pInputText
                               formControlName="fontName" />
                    </div>

                    <div class="col-6 md:col-3" formGroupName="headerFormat">
                        <label for="HeaderFontColor">
                            Header Format Font Color

                            <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                               (mouseover)="getContolTip('HEADERFORMATFONTCOLOR')"></i>

                        </label>
                        <input id="HeaderFontColor"
                               type="text"
                               pInputText
                               formControlName="fontColor" />
                    </div>

                    <div class="col-6 md:col-3" formGroupName="headerFormat">
                        <label class="pl-3 Font">
                            Header blank
                        </label>
                        <span>
                            <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('HEADERBLANK')"></i>
                        </span>
                        <span class="p-float-label pl-2 P">
                            <p-dropdown [options]="headerBlankOptions"
                                        optionLabel="value"
                                        optionValue="key"
                                        dataKey="value">
                            </p-dropdown>

                        </span>

                    </div>
                </div>
            </div>

            <h5 class="col-5 md:col-1 blueBar mt-4 mb-2 ml-2 mr-3 r-2">
                Billing Settings
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid paddingl">

                <div class="col-6 md:col-3">
                    <span>
                        <input id="EnableBilling"
                               type="checkbox"
                               formControlName="enableBilling"
                               binary="true" />
                        <label class="pl-2 Font">
                            Patient Billing
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('PATIENTBILLING')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-6 md:col-3">
                    <label for="BillingXMLDataPath">
                        Billing XML Data Path
                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('BILLINGXML')"></i>
                    </label>
                    <input id="BillingXMLDataPath"
                           type="text"
                           pInputText
                           formControlName="billingXMLDataPath"
                           [disabled]="isDisabled_EnableBilling" />
                </div>

                <div class="col-6 md:col-3">
                    <label for="InPatientXMLFile">
                        List1 File Name

                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('LIST1FILENAME')"></i>

                    </label>
                    <input id="InPatientXMLFile"
                           type="text"
                           pInputText
                           formControlName="inpatientFilePath"
                           [disabled]="isDisabled_EnableBilling" />
                </div>

                <div class="col-6 md:col-3">
                    <label for="InPatientLabel">
                        Alias for List1

                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('ALIASFORLIST1')"></i>

                    </label>
                    <input id="InPatientLabel"
                           type="text"
                           pInputText
                           formControlName="inpatientLabelText"
                           [disabled]="isDisabled_EnableBilling" />
                </div>

                <div class="col-6 md:col-3">
                    <label class="pl-3 Font" for="OutPatientLabel">
                        List2 File Name
                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('LIST2FILENAME')"></i>
                    </label>
                    <span class="Font">
                        <input id="OutPatientLabel" type="text" pInputText formControlName="outpatientFilePath" [disabled]="isDisabled_EnableBilling" />
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <label for="OutPatientXMLFile">
                        Alias for List2

                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('ALIASFORLIST2')"></i>

                    </label>
                    <input id="OutPatientXMLFile"
                           type="text"
                           pInputText
                           formControlName="outpatientLabelText"
                           [disabled]="isDisabled_EnableBilling" />
                </div>

                <div class="col-6 md:col-3">
                    <label for="OfficeLabel">
                        List3 File Name

                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('LIST3FILENAME')"></i>
                    </label>
                    <input id="OfficeLabel"
                           type="text"
                           pInputText
                           formControlName="officeFilePath"
                           [disabled]="isDisabled_EnableBilling" />
                </div>

                <div class="col-6 md:col-3">
                    <label for="OfficeXMLFile">
                        Alias for List3


                        <i class="pi pi-exclamation-circle pt-1  custom-tooltip" pTooltip="{{ speakText }}" tooltipPosition="right"
                           (mouseover)="getContolTip('ALIASFORLIST3')"></i>

                    </label>
                    <input id="OfficeXMLFile"
                           type="text"
                           pInputText
                           formControlName="officeLabelText"
                           [disabled]="isDisabled_EnableBilling" />
                </div>
            </div>

            <h5 class="col-5 md:col-1 blueBar mt-4 mb-2 ml-2 mr-3 r-2">
                Financial Settings
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid paddingl">

                <div class="col-6 md:col-3">
                    <span>
                        <input id="ViewInsuranceCard"
                               type="checkbox"
                               formControlName="viewInsuranceCard"
                               binary="true" />
                        <label class="pl-2 Font" for="ViewInsuranceCard">
                            View Insurance Card
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('VIEWINSURANCECARD')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="ViewEOBImage"
                               type="checkbox"
                               formControlName="viewEOBImage"
                               binary="true" />
                        <label class="pl-2 Font" for="ViewEOBImage">
                            View EOB Image
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('VIEWEOBIMAGE')"></i>
                        </label>
                    </span>
                </div>
            </div>

            <h5 class="col-5 md:col-1 blueBar mt-4 mb-2 ml-2 mr-3 r-2">
                Document Header Settings
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid paddingcb">
                <div class="col-6 md:col-3" formGroupName="pdfWaterMarkSettings">
                    <span>
                        <input id="EnablePatientHeader"
                               type="checkbox"
                               formControlName="enabled"
                               binary="true" />
                        <label class="pl-2 Font">
                            Enable Patient Header
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('DOCENABLEPATIENTHEADER')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3" formGroupName="pdfWaterMarkSettings">
                    <span>
                        <input id="WaterMarkPtName"
                               type="checkbox"
                               formControlName="addPatientName"
                               [disabled]="isDisabled_PdfWaterMark" />
                        <label class="pl-2 Font">
                            Patient Name
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('DOCPATIENTNAME')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3" formGroupName="pdfWaterMarkSettings">
                    <span>
                        <input id="WaterMarkGender"
                               type="checkbox"
                               formControlName="addGender"
                               binary="true"
                               [disabled]="isDisabled_PdfWaterMark" />
                        <label class="pl-2 Font">
                            Gender
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('DOCGENDER')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-6 md:col-3" formGroupName="pdfWaterMarkSettings">
                    <span>
                        <input id="WaterMarkDOB"
                               type="checkbox"
                               formControlName="addDOB"
                               binary="true"
                               [disabled]="isDisabled_PdfWaterMark" />
                        <label class="pl-2 Font">
                            DOB
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('DOCDOB')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-6 md:col-3" formGroupName="pdfWaterMarkSettings">
                    <span>
                        <input id="WaterMarkMRN"
                               type="checkbox"
                               formControlName="addMRN"
                               binary="true"
                               [disabled]="isDisabled_PdfWaterMark" />
                        <label class="pl-2 Font">
                            MRN<i class="pi pi-exclamation-circle pt-1"
                                  pTooltip="{{ speakText }}"
                                  tooltipPosition="right"
                                  (mouseover)="getContolTip('DOCMRN')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-6 md:col-3" formGroupName="pdfWaterMarkSettings">
                    <span>
                        <input id="WaterMarkSSN"
                               type="checkbox"
                               formControlName="addSSN"
                               binary="true"
                               [disabled]="isDisabled_PdfWaterMark" />
                        <label class="pl-2 Font">
                            SSN<i class="pi pi-exclamation-circle pt-1"
                                  pTooltip="{{ speakText }}"
                                  tooltipPosition="right"
                                  (mouseover)="getContolTip('DOCSSN')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-6 md:col-3" formGroupName="pdfWaterMarkSettings">
                    <span>
                        <input id="WaterMarkVisitdate"
                               type="checkbox"
                               formControlName="addVisitDate"
                               binary="true"
                               [disabled]="isDisabled_PdfWaterMark" />
                        <label class="pl-2 Font">
                            Visit Date<i class="pi pi-exclamation-circle pt-1"
                                         pTooltip="{{ speakText }}"
                                         tooltipPosition="right"
                                         (mouseover)="getContolTip('VISITDATE')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3" formGroupName="pdfWaterMarkSettings">
                    <span>
                        <input id="WaterMarkDescription"
                               type="checkbox"
                               formControlName="addDescription"
                               binary="true"
                               [disabled]="isDisabled_PdfWaterMark" />
                        <label class="pl-2 Font">
                            Description<i class="pi pi-exclamation-circle pt-1"
                                          pTooltip="{{ speakText }}"
                                          tooltipPosition="right"
                                          (mouseover)="getContolTip('DESCRIPTION')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-12 md:col-12" formGroupName="pdfWaterMarkSettings">
                    <span>
                        <input id="WaterMarkLoc"
                               type="checkbox"
                               binary="true"
                               formControlName="addLocation"
                               [disabled]="isDisabled_PdfWaterMark" />
                        <label class="pl-2 Font">
                            Location<i class="pi pi-exclamation-circle pt-1"
                                       pTooltip="{{ speakText }}"
                                       tooltipPosition="right"
                                       (mouseover)="getContolTip('LOCATION')"></i>
                        </label>
                    </span>
                </div>
            </div>

            <div class="col-12 grid paddingl" formGroupName="pdfWaterMarkSettings">
                <div class="col-6 md:col-3  pl-3">
                    <label for="LocationX">Location X</label>
                    <input id="LocationX"
                           type="number"
                           pInputText
                           formControlName="locationX"
                           [disabled]="isDisabled_PdfWaterMark" />
                </div>
                <div class="col-6 md:col-3">
                    <label for="LocationY">Location Y</label>
                    <input id="LocationY"
                           type="number"
                           pInputText
                           formControlName="locationY"
                           [disabled]="isDisabled_PdfWaterMark" />
                </div>
                <div class="col-6 md:col-3">
                    <label for="WaterMarkLabelMrn">Alias For MRN</label>
                    <input id="WaterMarkLabelMrn"
                           type="text"
                           pInputText
                           formControlName="mrnLabel"
                           [disabled]="isDisabled_PdfWaterMark" />
                </div>

                <div class="col-6 md:col-3">
                    <label for="WaterMarkLabelLocation">Alias For Location</label>
                    <input id="WatermarkLocation"
                           type="text"
                           pInputText
                           formControlName="locationLabel"
                           [disabled]="isDisabled_PdfWaterMark" />
                </div>
            </div>

            <h5 class="col-5 md:col-1 blueBar mt-4 mb-2 ml-2 mr-3 r-2">
                Notes Header Settings
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid paddingcb" formGroupName="notesWaterMarkSettings">
                <div class="col-6 md:col-3">
                    <span>
                        <input id="NotesEnableWatermark"
                               type="checkbox"
                               binary="true"
                               formControlName="enabled" />
                        <label class="pl-2 Font">
                            Enable Notes Header
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('NOTEENABLEPATIENTHEADER')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="NotesWaterMarkPtName"
                               type="checkbox"
                               binary="true"
                               formControlName="addPatientName"
                               [disabled]="isDisabled_NotesWaterMark" />
                        <label class="pl-2 Font">
                            Patient Name
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('NOTEPATIENTNAME')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <input id="NotesWaterMarkGender"
                               type="checkbox"
                               binary="true"
                               formControlName="addGender"
                               [disabled]="isDisabled_NotesWaterMark" />
                        <label class="pl-2 Font">
                            Gender<i class="pi pi-exclamation-circle pt-1"
                                     pTooltip="{{ speakText }}"
                                     tooltipPosition="right"
                                     (mouseover)="getContolTip('NOTEGENDER')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-6 md:col-3">
                    <span>
                        <input id="NotesWaterMarkDOB"
                               type="checkbox"
                               binary="true"
                               formControlName="addDOB"
                               [disabled]="isDisabled_NotesWaterMark" />
                        <label class="pl-2 Font">
                            DOB
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('NOTEDOB')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-6 md:col-3">
                    <span>
                        <input id="NotesWaterMarkMRN"
                               type="checkbox"
                               binary="true"
                               formControlName="addMRN"
                               [disabled]="isDisabled_NotesWaterMark" />
                        <label class="pl-2 Font">
                            MRN
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('NOTEMRN')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-6 md:col-3">
                    <span>
                        <input id="NotesWaterMarkSSN"
                               type="checkbox"
                               binary="true"
                               formControlName="addSSN"
                               [disabled]="isDisabled_NotesWaterMark" />
                        <label class="pl-2 Font">
                            SSN<i class="pi pi-exclamation-circle pt-1"
                                  pTooltip="{{ speakText }}"
                                  tooltipPosition="right"
                                  (mouseover)="getContolTip('NOTESSN')"></i>
                        </label>
                    </span>
                </div>


            </div>

            <div class="col-12 grid paddingl" formGroupName="notesWaterMarkSettings">
                <div class="col-6 md:col-3 pl-3">
                    <label for="NotesLocationX">Location X</label>
                    <input id="NotesLocationX"
                           type="number"
                           pInputText
                           formControlName="locationX"
                           [disabled]="isDisabled_NotesWaterMark" />
                </div>
                <div class="col-6 md:col-3">
                    <label for="LocationY">Location Y</label>
                    <input id="LocationY"
                           type="number"
                           pInputText
                           formControlName="locationY"
                           [disabled]="isDisabled_NotesWaterMark" />
                </div>
                <div class="col-6 md:col-3">
                    <label for="NotesWaterMarkLabelMrn">Alias For MRN</label>
                    <input id="NotesWaterMarkLabelMrn"
                           type="text"
                           pInputText
                           formControlName="mrnLabel"
                           [disabled]="isDisabled_NotesWaterMark" />
                </div>
            </div>
        </p-panel>

        <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
        <!--<button P-button class="buttonWidth-8" type="submit">Save Settings</button>-->
        <div class="row">
            <div class="col-12">
                <span style="float:left">
                    <button pButton
                            type="submit"
                            icon="pi pi-save"
                            label="Save Practice Configuration"
                            class="p-button-plain ml-4"
                            title="Save all settings" [disabled]="isSaving"></button>&nbsp;
                </span>
            </div>
        </div>
        <div class="row p-1">
            &nbsp;
        </div>


    </form>
</div>
<p-dialog header="Practice Message"
          [(visible)]="showPracticeMessage"
          [draggable]="false"
          [modal]="true"
          positionType="absolute"
          [closable]="false"
          [maximizable]="false"
          [style]="{ width: '20vw' }">
    <div [innerHtml]="practiceMessage"></div>
    <div class="flex flex-row-reverse">
        <p-button label="OK" (click)="resetPracticeMessage()"></p-button>
    </div>
</p-dialog>
